module.exports = __webpack_public_path__ + "media/images/mission_icon_2-c9712fdd7baf3bb81aca837761817402.svg";